import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { InspectionInformationDBService } from '@core/db/inspection-information-db-service';
import { InspectionInformationDto } from 'src/app/dtos/inspectionInformationDto';

@Injectable()
export class InspectionInformationResolver implements Resolve<InspectionInformationDto> {
  private inspectionInformationDbService = inject(InspectionInformationDBService);

  public resolve(route: ActivatedRouteSnapshot) {
    return this.inspectionInformationDbService.getInspectionInformation(
      route.paramMap.get('inspectionKey'),
    );
  }
}
